import saMessages from '../locales/ru_RU.json';

const saLang = {
  messages: {
    ...saMessages,
  },
  locale: 'ru-RU',
};
export default saLang;
